import SyncSegmentsCard from './SyncSegmentsCard';
import SyncSegmentsStatus from './SyncSegmentsStatus';

const SyncSegmentsCards = ({ segmentSyncs, toggleSegmentSync }) => {
  const segmentSyncElements = [];

  for (let i = 0; i < segmentSyncs.length; i++) {
    const segmentSync = segmentSyncs[i];
    let status = <SyncSegmentsStatus i={i} segmentSync={segmentSync} toggleSegmentSync={toggleSegmentSync} />;
    segmentSyncElements.push(<SyncSegmentsCard key={segmentSync.id} segmentSync={segmentSync} status={status} />);
  }

  return segmentSyncElements;
};

export default SyncSegmentsCards;
